import React, { useEffect, useRef, useState } from "react";
import { toast, ToastItem } from "react-toastify";

const getTextFromReactNode = (node: React.ReactNode): string => {
  if (node === null || node === undefined || typeof node === "boolean") {
    return "";
  }

  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map(getTextFromReactNode).join(" ").trim();
  }

  if (React.isValidElement(node)) {
    return getTextFromReactNode(node.props?.children);
  }

  return "";
};

const GlobalToastLiveAnnouncer = () => {
  const [announcement, setAnnouncement] = useState("");
  const announceTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const unsubscribe = toast.onChange((payload: ToastItem) => {
      if (payload.status !== "added") {
        return;
      }

      const message = getTextFromReactNode(payload.content).trim();
      if (!message) {
        return;
      }

      if (announceTimeoutRef.current) {
        clearTimeout(announceTimeoutRef.current);
      }
      setAnnouncement("");
      announceTimeoutRef.current = setTimeout(() => {
        setAnnouncement(message);
        announceTimeoutRef.current = null;
      }, 100);
    });

    return () => {
      unsubscribe();
      if (announceTimeoutRef.current) {
        clearTimeout(announceTimeoutRef.current);
        announceTimeoutRef.current = null;
      }
    };
  }, []);

  return (
    <div
      className="app-toast-live-announcer"
      aria-live="assertive"
      aria-atomic="true"
      role="status"
    >
      {announcement}
    </div>
  );
};

export default GlobalToastLiveAnnouncer;
